import { encodeCode128B, encodeEan13, ean13CheckDigit, validateCode128 } from '../../../utils/etiqueta/barcode';
import { barcodeLayout } from '../../../utils/etiqueta/barcodeLayout';
import { renderSample } from '../../../utils/etiqueta/macros';

function Barras({ modules, showText, text, scale, fontSize, barHeight, moduleWidth }) {
  const width = (modules.length * moduleWidth * 25.4) / 203 * scale;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width }}>
      <svg viewBox={`0 0 ${modules.length} 100`} preserveAspectRatio="none" style={{ width: '100%', height: barHeight * scale }}>
        {[...modules].map((bit, i) => (
          bit === '1' ? <rect key={i} x={i} y={0} width={1.02} height={100} fill="#111" /> : null
        ))}
      </svg>
      {showText && (
        <div style={{ textAlign: 'center', fontFamily: 'monospace', fontSize: fontSize * scale, lineHeight: 1.2, color: '#111', whiteSpace: 'nowrap' }}>
          {text}
        </div>
      )}
    </div>
  );
}

function CodigoBarras({ el, data, scale, mostrarMacros }) {
  if (mostrarMacros) {
    return (
      <div style={{
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px dashed #1565c0',
        color: '#1565c0',
        fontSize: Math.max(8, 9 * scale / 4),
        fontFamily: 'monospace',
        padding: 2,
        textAlign: 'center',
        wordBreak: 'break-all',
      }}
      >
        {el.content || 'código'}
      </div>
    );
  }
  const valor = renderSample(el.content, data);
  let modules = null;
  if (el.symbology === 'EAN13' && /^\d{12,13}$/.test(valor)) modules = encodeEan13(valor.slice(0, 12));
  if (el.symbology === 'CODE128' && !validateCode128(valor)) modules = encodeCode128B(valor);
  if (!modules) {
    return (
      <div style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px dashed #d32f2f',
        color: '#d32f2f',
        fontSize: 9,
        fontFamily: 'monospace',
      }}
      >
        dado inválido
      </div>
    );
  }
  const layout = barcodeLayout(el);
  const texto = valor.length === 12 && el.symbology === 'EAN13' ? valor + ean13CheckDigit(valor) : valor;
  return (
    <Barras
      modules={modules}
      showText={el.showText}
      text={texto}
      scale={scale}
      fontSize={layout.fontSize}
      barHeight={layout.barHeight}
      moduleWidth={el.moduleWidth}
    />
  );
}

export default function ElementoEtiqueta({ el, scale, data, mostrarMacros = false }) {
  if (el.type === 'line') return <div style={{ width: '100%', height: '100%', background: '#111' }} />;
  if (el.type === 'rect') {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        border: `${Math.max(1, el.thickness * scale)}px solid #111`,
      }}
      />
    );
  }
  const rotated = el.rotation % 180 !== 0;
  const innerW = (rotated ? el.h : el.w) * scale;
  const innerH = (rotated ? el.w : el.h) * scale;
  const texto = mostrarMacros ? (el.content || '\u00a0') : (renderSample(el.content, data) || '\u00a0');
  const inner = el.type === 'barcode' ? (
    <div style={{ width: innerW, height: innerH }}>
      <CodigoBarras el={el} data={data} scale={scale} mostrarMacros={mostrarMacros} />
    </div>
  ) : (
    <div style={{
      width: innerW,
      height: innerH,
      overflow: 'hidden',
      color: mostrarMacros ? '#1565c0' : '#111',
      fontSize: el.fontSize * scale * 0.92,
      lineHeight: 1.15,
      fontFamily: mostrarMacros ? 'monospace' : "'Arial Narrow', Arial, sans-serif",
      fontWeight: el.bold ? 700 : 400,
      textAlign: el.align,
      whiteSpace: el.maxLines > 1 ? 'normal' : 'nowrap',
    }}
    >
      {texto}
    </div>
  );
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: innerW,
        height: innerH,
        transform: `translate(-50%, -50%) rotate(${el.rotation}deg)`,
      }}
      >
        {inner}
      </div>
    </div>
  );
}
